var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-block pt-12"},[_c('v-expansion-panels',{attrs:{"id":"faq-container","multiple":"","focusable":"","tile":""}},[(_vm.customFAQ && _vm.customFAQ.length)?_vm._l((_vm.customFAQ),function(section,index){return _c('faq-section',{key:index,attrs:{"header":section.header,"response":section.body}})}):_vm._l(([
          '01',
          '02',
          '03',
          '04',
          '05',
          '06',
          '07',
          '08',
          '09',
          '10',
          '11',
          '12',
          '13'
        ]),function(item){return _c('faq-section',{key:("faq" + item),attrs:{"header":_vm.$t(("faq" + item + "-header")),"response":_vm.$t(("faq" + item + "-response")),"index":("faq" + item)}})})],2),_c('back-button')],1)}
var staticRenderFns = []

export { render, staticRenderFns }